module.exports = __webpack_public_path__ + "img/patio_de_chon_sau.64a00285.jpg";